import React, { useRef, useState, useEffect } from 'react'
import './notification.sass'
import {useSelector} from 'react-redux';

import Header from '../../components/common/Header'
import { LikeComponent, CommentComponent, PhotoTip, ChatTip, SubscribedTip, NotificationsTab } from '../../components/notification'
import { loadCommentNotifications, loadLikeNotifications } from '../../api/notification'
import { getUserByID } from '../../api/auth';
import { EmptyScreen } from '../../components/common/EmptyScreen';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { NotificationShimmer } from '../../components/common/Shimmer';

export default function Notification() {
    const likesRef = useRef(0)
    const commentsRef = useRef(0)
    const walletRef = useRef(0)

    const [isMobile, setIsMobile] = useState(false);
    const [currentActiveTab, setCurrentActiveTab] = useState(0);
    const [width, setWidth] = useState(document.body.clientWidth);
    const [loadingLikes, setLoadingLikes] = useState(true);
    const [loadingComments, setLoadingComments] = useState(true);
    let isDark = useSelector(state => state.isDark);

    const [commentNotifications, setCommentNotifications] = useState([])
    const [likeNotifications, setLikeNotifications] = useState([])

    const updateWidth = () => {
        setWidth(document.body.clientWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', updateWidth);

        if(width <= 580){
            document.getElementById('mainWrapper').classList.remove('padding')
            document.getElementById('mainWrapper').classList.add('zero-p')
            // console.log("updating the view from notification.js")
            document.getElementById('mainWrapper').style.cssText = "padding: 70px 0 0 0 !important"
            document.getElementById('mobileNav').style.display = "none"
        }else{
            document.getElementById('mainWrapper').classList.add('padding')
            document.getElementById('mainWrapper').classList.remove('zero-p')
            console.log("updating the view from notification.js")
            document.getElementById('mobileNav').style.display = "none"
        }
        if (width <= 830) {
            setIsMobile(true);
            try {
                if(currentActiveTab === 0){
                    commentsRef.current.style.display = "none";
                    walletRef.current.style.display = "none";
                    likesRef.current.style.display = "block"
                    likesRef.current.style.maxWidth = "100%"
                    likesRef.current.style.flex = "100%"
                    likesRef.current.style.paddingRight = "0px"
                } else if(currentActiveTab === 1){
                    likesRef.current.style.display = "none";
                    walletRef.current.style.display = "none";
                    commentsRef.current.style.display = "block"
                    commentsRef.current.style.maxWidth = "100%"
                    commentsRef.current.style.flex = "100%"
                    commentsRef.current.style.paddingRight = "0px"
                } else if(currentActiveTab === 2){
                    commentsRef.current.style.display = "none";
                    likesRef.current.style.display = "none";
                    walletRef.current.style.display = "block"
                    walletRef.current.style.maxWidth = "100%"
                    walletRef.current.style.flex = "100%"
                    walletRef.current.style.paddingRight = "0px"
                }

            } catch (e) { }
        }
        else {
            setIsMobile(false)
            try {
                walletRef.current.style.display = "block";
                commentsRef.current.style.display = "block";
                likesRef.current.style.display = "block";


                likesRef.current.style.maxWidth = "33.3%"
                likesRef.current.style.flex = "33.3%"
                likesRef.current.style.paddingRight = "10px"

                walletRef.current.style.maxWidth = "33.3%"
                walletRef.current.style.flex = "33.3%"
                walletRef.current.style.paddingLeft = "10px"

                commentsRef.current.style.maxWidth = "33.3%"
                commentsRef.current.style.flex = "33.3%"
                commentsRef.current.style.padding = "0px 5px"
            } catch (e) {

            }
        }

        return () => {
            window.removeEventListener('resize', updateWidth);
            document.getElementById('mobileNav').style.display = 'flex';
        }

    }, [width])


    const updateView = (v) => {
        // if(v <= 580){
        //     document.getElementById('mainWrapper').classList.remove('padding')
        //     document.getElementById('mainWrapper').classList.add('zero-p')
        //     console.log("updating the view from notification.js")
        //     document.getElementById('mobileNav').style.display = "none"
        // }else{
        //     document.getElementById('mainWrapper').classList.add('padding')
        //     document.getElementById('mainWrapper').classList.remove('zero-p')
        //     console.log("updating the view from notification.js")
        //     document.getElementById('mobileNav').style.display = "none"
        // }
        // if (v <= 830) {
        //     setIsMobile(true);
        //     try {
        //         if(currentActiveTab === 0){
        //             commentsRef.current.style.display = "none";
        //             walletRef.current.style.display = "none";
        //             likesRef.current.style.display = "block"
        //             likesRef.current.style.maxWidth = "100%"
        //             likesRef.current.style.flex = "100%"
        //             likesRef.current.style.paddingRight = "0px"
        //         } else if(currentActiveTab === 1){
        //             likesRef.current.style.display = "none";
        //             walletRef.current.style.display = "none";
        //             commentsRef.current.style.display = "block"
        //             commentsRef.current.style.maxWidth = "100%"
        //             commentsRef.current.style.flex = "100%"
        //             commentsRef.current.style.paddingRight = "0px"
        //         } else if(currentActiveTab === 2){
        //             commentsRef.current.style.display = "none";
        //             likesRef.current.style.display = "none";
        //             walletRef.current.style.display = "block"
        //             walletRef.current.style.maxWidth = "100%"
        //             walletRef.current.style.flex = "100%"
        //             walletRef.current.style.paddingRight = "0px"
        //         }

        //     } catch (e) { }
        // }
        // else {
        //     setIsMobile(false)
        //     try {
        //         walletRef.current.style.display = "block";
        //         commentsRef.current.style.display = "block";
        //         likesRef.current.style.display = "block";


        //         likesRef.current.style.maxWidth = "33.3%"
        //         likesRef.current.style.flex = "33.3%"
        //         likesRef.current.style.paddingRight = "10px"

        //         walletRef.current.style.maxWidth = "33.3%"
        //         walletRef.current.style.flex = "33.3%"
        //         walletRef.current.style.paddingLeft = "10px"

        //         commentsRef.current.style.maxWidth = "33.3%"
        //         commentsRef.current.style.flex = "33.3%"
        //         commentsRef.current.style.padding = "0px 5px"
        //     } catch (e) {

        //     }
        // }
    }

    // const emptyEvent = () => {
    //     console.log('ha ha ha ha i am empty boi');
    // }

    // useEffect(() => {
    //     updateView(window.innerWidth)
    //     if(document.body.clientWidth < 580){
    //         document.getElementById('mainWrapper').style.cssText = "padding: 70px 10px 70px 10px !important"
    //     } else {
    //         document.getElementById('mainWrapper').style.cssText = "padding: 100px 0 0 0 !important"
    //     }
    //     // window.addEventListener('resize', v => {
    //     //     updateView(v.target.innerWidth)
    
    //     // })

    //     // return () => {
    //     //     window.removeEventListener('resize', emptyEvent)
    //     // }
    // }, [])


    const updateTab = (e, setIsActive) => {
        if (e == 0) {
            try {
                likesRef.current.style.display = "block";
                likesRef.current.style.maxWidth = "100%"
                likesRef.current.style.flex = "100%"
                likesRef.current.style.paddingRight = "0px"
                setIsActive(0);
                setCurrentActiveTab(0)
                commentsRef.current.style.display = "none";
                walletRef.current.style.display = "none";
            } catch (e) { }
        } else if (e == 1) {
            try {
                commentsRef.current.style.display = "block";
                commentsRef.current.style.maxWidth = "100%"
                commentsRef.current.style.flex = "100%"
                commentsRef.current.style.paddingRight = "0px"
                setIsActive(1);
                setCurrentActiveTab(1)
                walletRef.current.style.display = "none";
                likesRef.current.style.display = "none";
            } catch (e) { }
        } else {
            try {
                walletRef.current.style.display = "block";
                walletRef.current.style.maxWidth = "100%"
                walletRef.current.style.flex = "100%"
                walletRef.current.style.paddingRight = "0px"
                setIsActive(2);
                setCurrentActiveTab(2)
                commentsRef.current.style.display = "none";
                likesRef.current.style.display = "none";
            } catch (e) { }
        }
    }

    const userID = useSelector(state => state.userState.id);


    useEffect(()=>{
        if(userID != null && userID != undefined){
        let tempComments = []
        let tempLikes = []
        loadCommentNotifications(userID, async observer=>{
            tempComments = []
            for (var i = 0; i < observer.docs.length; i++){
                tempComments.push({
                    data: observer.docs[i].data(),
                    commentedBy: observer.docs[i].data().commentedBy
                });
            }

            
            setCommentNotifications(tempComments)
            setLoadingComments(false);
        })

        loadLikeNotifications(userID, async observer=>{
            tempLikes = []
            for (var i = 0; i < observer.docs.length; i++){
               // const likedBy = await getUserByID(observer.docs[i].data().likedBy)
                tempLikes.push({
                    data: observer.docs[i].data(),
                    likedBy: observer.docs[i].data().likedBy
                });
            }

            // console.log("likes", tempLikes)


            setLikeNotifications(tempLikes)
            setLoadingLikes(false)
        })
    }
    }, [userID])


    return (
        <div id="notificationWrapper">
            { isMobile ? <div id="notificationTabBar"> <NotificationsTab title="Activity" onUpdate={updateTab} text="Likes" img="heart" text2="Comments" img2="comment" text3="Wallet" img3="tip" />  </div> : ''}

            <div id="notificationRow">

                <div ref={likesRef} id="notificationLCol">
                    {!isMobile ? <Header img='heart.svg' text="Likes" /> : <div> </div>}
                    {
                        loadingLikes ?
                        <div>
                            
                        </div> :        
                        (likeNotifications.length === 0 && likeNotifications) ?
                        <EmptyScreen logo='heart_a' heading='No likes' description='There are no new received likes on your activity.' /> :
                        likeNotifications.map(cNotification => <LikeComponent key={cNotification.data.likedBy} data={cNotification.data} user={cNotification.likedBy}/>)
                    }

                </div>
                <div ref={commentsRef} id="notificationCCol">
                    {!isMobile ? <Header img='comment.svg' text="Comments" /> : <div> </div>}
                    {
                        loadingComments ?
                        <div>
                            
                        </div> :
                        (commentNotifications.length === 0 && commentNotifications) ?
                        <EmptyScreen logo='comment_a' heading='No comments' description='There are no new comments left on your activity.' /> :
                        commentNotifications.map(cNotification => <CommentComponent key={cNotification.data.uid} data={cNotification.data} user={cNotification.commentedBy}/>)
                    }
                </div>
                <div ref={walletRef} id="notificationRCol">
                    {!isMobile ? <Header img='tip.svg' text="Wallet" /> : <div> </div>}
                    {/* as there is no function for transction so iam putting this simply */}
                    <EmptyScreen logo='tip_a' heading='No money activity' description='There are no new subcriptions or received tips.' />
                    {/* <PhotoTip />
                    <ChatTip />
                    <SubscribedTip /> */}
                </div>
            </div>
        </div>
    )
}
